import { render, staticRenderFns } from "./JSONPage.vue?vue&type=template&id=64a1a59a&"
import script from "./JSONPage.vue?vue&type=script&lang=ts&"
export * from "./JSONPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports